module.exports = __webpack_public_path__ + "static/media/nian.7cf6fe9.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/springFestival/mp3/nian.mp3
// module id = lqUr
// module chunks = 5